import { apiClient } from './client';

/** Teams — staff org structure (Call Center / Sales / Control). Admin-only. */

export async function getTeams() {
  const { data } = await apiClient.get('/teams');
  return data;
}

export async function getTeamStats() {
  const { data } = await apiClient.get('/teams/stats');
  return data;
}

/** Current staff member's teams + effective CRM functional role (for feature gating). */
export async function getMyTeamContext() {
  const { data } = await apiClient.get('/teams/me');
  return data;
}

export async function getTeam(id) {
  const { data } = await apiClient.get(`/teams/${id}`);
  return data;
}

export async function createTeam(body) {
  const { data } = await apiClient.post('/teams', body);
  return data;
}

export async function updateTeam(id, body) {
  const { data } = await apiClient.put(`/teams/${id}`, body);
  return data;
}

export async function deleteTeam(id) {
  const { data } = await apiClient.delete(`/teams/${id}`);
  return data;
}

export async function addTeamMember(teamId, body) {
  const { data } = await apiClient.post(`/teams/${teamId}/members`, body);
  return data;
}

export async function updateTeamMember(teamId, memberId, body) {
  const { data } = await apiClient.patch(`/teams/${teamId}/members/${memberId}`, body);
  return data;
}

export async function removeTeamMember(teamId, memberId) {
  const { data } = await apiClient.delete(`/teams/${teamId}/members/${memberId}`);
  return data;
}
